import React, { useEffect, useState } from "react";
import QRCode from 'qrcode.react';
import { Typography, TextField, Button, Box } from "@mui/material";
import { axiosPost } from "../../services/axios/apiCalls";

function CardMail2fa({ systemData, loginUser, loginData, launchErrorModal }) {
    /** QR */
    const [otpAuth, setOtpAuth] = useState('')
    const [hasQr, setHasQr] = useState(true)

    /** CONST */
    const textInputProps = { maxLength: 6 }
    const [pass, setPass] = useState('')

    async function handleSubmit(event) {
        event.preventDefault();
        await loginUser(loginData.user, pass, loginData.auth_type);
    }

    return (
        <>
            <Box className="custom-2fa-card col-lg-4 col-md-6 col-sm-9 col-11 kiwox-panel shadow d-flex flex-column align-items-center">
                <div className="pb-4">
                    <img src={systemData.entry_logo} alt="report-automator" />
                </div>
                {/* ------------------------------ START TEXTO EN LOGIN EDITABLE ------------------------------ */}
                <Typography className="fs-5 mb-3 login-title">{systemData.login_title}</Typography>
                {/* ------------------------------ END TEXTO EN LOGIN EDITABLE ------------------------------ */}
                {/* ------------------------------ START QR ------------------------------ */}
                <div>
                    Consulta tu correo electrónico para ingresar tu código temporal
                </div>
                {/* ------------------------------ END QR ------------------------------ */}
                <form className="box-form" onSubmit={handleSubmit}>
                    {/** Campo password */}
                    <TextField
                        className="form-password mb-1 mt-1"
                        required
                        id="pass"
                        name="pass"
                        label="Pass"
                        type="password"
                        value={pass}
                        inputProps={textInputProps}
                        onChange={(event) => {
                            const re = /^[0-9\b]+$/;
                            if (event.target.value === '' || re.test(event.target.value))
                                setPass(event.target.value)
                        }}
                        size="small"
                    />
                    {/** Botón login */}
                    <Button className="btn-principal col-7 mt-4" type="submit">
                        Verificar
                    </Button>
                </form>
            </Box>
        </>
    )
}

export default CardMail2fa;